import React from "react";
import { useParams } from 'react-router-dom';
import { Drawer, Accordion, Group, ActionIcon, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils, ROOT_BASE_URL } from "../../utils/globalVariables";

import ImageLightBox2 from "../../components/general/ImageLightBox2";
import SegeraJemputNotaBasicData from "../trxDeliverySegeraJemput/SegeraJemputNotaBasicData";
import SedangJemputInputData from "../trxDeliverySedangJemput/SedangJemputInputData";
import SudahInputSerahTerima from "../trxDeliverySudahInput/SudahInputSerahTerima";
import SudahSerahTerimaBuatNota from "./SudahSerahTerimaBuatNota";

const SudahSerahTerimaSelected = ({ fnCloseDrawer, fnDirectURLNota, fnRefreshIndex, fnSuccessBatal }) => {

    const { URI1 } = useParams();

    const utilsRef = React.useRef({
        currentStep: utils.penjemputanSteps.sudah_serah_terima.value,
        isCancel: '0',
        userAccess: [
            // role.owner.subLevel.owner.slugSubLevel,
            // role.admin.subLevel.admin_kepala.slugSubLevel,
            // role.admin.subLevel.admin_staf.slugSubLevel,
        ]
    })

    const [data, setData] = React.useState({
        imageLightboxImages: '',
        imageLightboxTitle: '',
        imageLightboxIndex: '',
        imageLightboxFieldName: '',
        imageLightboxShow: false,
    });

    return (
        <React.Fragment>
            <Drawer
                opened={URI1}
                onClose={fnCloseDrawer}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnCloseDrawer}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Delivery Penjemputan</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Accordion
                    variant="separated"
                    multiple
                    defaultValue={["delivery-jemput-select-item-for-nota"]}

                    styles={(tema) => ({
                        control: {
                            backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[6],
                            borderTopLeftRadius: tema.radius.sm,
                            borderTopRightRadius: tema.radius.sm,
                        }
                    })}
                >
                    <Accordion.Item value="delivery-jemput-basic-data">
                        <Accordion.Control>Data Penjemputan</Accordion.Control>
                        <Accordion.Panel pt='md'>
                            <SegeraJemputNotaBasicData
                                stateData={{
                                    utilsRef: utilsRef.current,
                                }}

                                fnRefreshIndex={fnRefreshIndex}
                                fnCloseDrawer={fnCloseDrawer}
                                fnSuccessSubmit={fnRefreshIndex}
                                fnSuccessBatal={fnSuccessBatal}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>

                    <Accordion.Item value="delivery-jemput-input-data">
                        <Accordion.Control>Input Data Penjemputan</Accordion.Control>
                        <Accordion.Panel pt='md'>
                            <SedangJemputInputData
                                stateData={{
                                    utilsRef: utilsRef.current,
                                }}

                                fnRefreshIndex={fnRefreshIndex}
                                fnCloseDrawer={fnCloseDrawer}
                                fnSuccessSubmit={fnRefreshIndex}
                                fnClickPhoto={(obj) => {
                                    setData(d => ({
                                        ...d,
                                        imageLightboxImages: obj.images,
                                        imageLightboxTitle: obj.title,
                                        imageLightboxIndex: obj.index,
                                        imageLightboxFieldName: obj.fieldName,
                                        imageLightboxShow: true,
                                    }))
                                }}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>

                    <Accordion.Item value="delivery-jemput-serah-terima">
                        <Accordion.Control>Serah Terima Barang</Accordion.Control>
                        <Accordion.Panel pt='md'>
                            <SudahInputSerahTerima
                                stateData={{
                                    utilsRef: utilsRef.current,
                                }}

                                fnRefreshIndex={fnRefreshIndex}
                                fnCloseDrawer={fnCloseDrawer}
                                fnSuccessSubmit={fnRefreshIndex}
                                fnClickPhoto={(obj) => {
                                    setData(d => ({
                                        ...d,
                                        imageLightboxImages: obj.images,
                                        imageLightboxTitle: obj.title,
                                        imageLightboxIndex: obj.index,
                                        imageLightboxFieldName: obj.fieldName,
                                        imageLightboxShow: true,
                                    }))
                                }}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>

                    <Accordion.Item value="delivery-jemput-select-item-for-nota">
                        <Accordion.Control>Buat Nota Baru</Accordion.Control>
                        <Accordion.Panel pt='md'>
                            <SudahSerahTerimaBuatNota
                                stateData={{
                                    utilsRef: utilsRef.current,
                                }}

                                fnRefreshIndex={fnRefreshIndex}
                                fnCloseDrawer={fnCloseDrawer}
                                fnSuccessSubmit={fnDirectURLNota}
                                fnClickPhoto={(obj) => {
                                    setData(d => ({
                                        ...d,
                                        imageLightboxImages: obj.images,
                                        imageLightboxTitle: obj.title,
                                        imageLightboxIndex: obj.index,
                                        imageLightboxFieldName: obj.fieldName,
                                        imageLightboxShow: true,
                                    }))
                                }}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>
                </Accordion>

                {/* <Box mt='sm' /> */}

                {/* <SerahTerimaSubmit
                    stateData={{
                        utilsRef: utilsRef.current,
                    }}

                    fnRefreshIndex={fnRefreshIndex}
                    fnCloseDrawer={fnCloseDrawer}
                    fnSuccessSubmit={fnRefreshIndex}
                /> */}
            </Drawer>

            <ImageLightBox2
                stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

                stateTitle={data.imageLightboxTitle}
                stateSelectedIndex={data.imageLightboxIndex}
                stateShow={data.imageLightboxShow}
                fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
            />
        </React.Fragment>
    )
}

export default React.memo(SudahSerahTerimaSelected);